module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"overview":"Overview"}}')
  delete Component.options._Ctor
}
